export const validateCustomLink = (link) => {
  const errors = {};

  errors.id = link.id;
  if (!link.label.trim()) {
    errors.label = "Label is required.";
  }

  const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i;
  if (!link.url.trim()) {
    errors.url = "URL is required.";
  } else if (!urlPattern.test(link.url.trim())) {
    errors.url = "Enter a valid URL.";
  }

  return errors;
};

export const getContrastTextColor = (bgColor) => {
  if (!bgColor) return "#000000";
  // Remove # if present
  const color = bgColor.charAt(0) === "#" ? bgColor.substring(1) : bgColor;

  // Convert hex to RGB
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  // YIQ contrast formula
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? "#000000" : "#FFFFFF"; // black or white
};
